import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
} from "@material-ui/core";
import React from "react";
import { useTranslation } from "react-i18next";

function Form059SubmittedDialog({ formOpen, onConfirm }) {
    const { t } = useTranslation();
    return (
        <React.Fragment>
            <Dialog aria-labelledby="simple-dialog-title" open={formOpen}>
                <DialogTitle id="simple-dialog-title">
                    {t("Form059.errorMsg.dialogTitle")}
                </DialogTitle>
                <DialogContent>
                    {t("Form059.errorMsg.dialogContent")}
                </DialogContent>
                <DialogActions>
                    <Button autoFocus onClick={onConfirm} color="success">
                        <b>{t("common.portal.close")}</b>
                    </Button>
                </DialogActions>
            </Dialog>
        </React.Fragment>
    );
}
export default Form059SubmittedDialog;
